import { createContext, useContext, useState, useCallback, useMemo } from "react";

const EditableContentContext = createContext();

export const EditableContentProvider = ({ children }) => {
  /* This is for the add product page */
  const [editableProductContent, setEditableProductContent] =
    useState("Untitled Item");

  /* This is for the create package page */
  const [editablePackageContent, setEditablePackageContent] =
    useState("Untitled Package");

  /* This is for the gallery page */
  const [editableGalleryContent, setEditableGalleryContent] =
    useState("Untitled Gallery");

  /* This is for the gallery page */
  const [editableGalleryMessageContent, setEditableGalleryMessageContent] =
    useState("Write a message or direction for your customer here.");

  /* Memoized handlers to prevent unnecessary re-renders */
  const handleProductContentChange = useCallback((newContent) => {
    setEditableProductContent(newContent);
  }, []);

  const handlePackageContentChange = useCallback((newContent) => {
    setEditablePackageContent(newContent);
  }, []);

  const handleGalleryContentChange = useCallback((newContent) => {
    setEditableGalleryContent(newContent);
  }, []);

  const handleGalleryMessageContentChange = useCallback((newContent) => {
    setEditableGalleryMessageContent(newContent);
  }, []);

  /* Memoize the context value to prevent unnecessary re-renders of consumers */
  const value = useMemo(() => ({
    editableProductContent,
    handleProductContentChange,
    editablePackageContent,
    handlePackageContentChange,
    editableGalleryContent,
    handleGalleryContentChange,
    editableGalleryMessageContent,
    handleGalleryMessageContentChange,
  }), [
    editableProductContent,
    handleProductContentChange,
    editablePackageContent,
    handlePackageContentChange,
    editableGalleryContent,
    handleGalleryContentChange,
    editableGalleryMessageContent,
    handleGalleryMessageContentChange,
  ]);

  return (
    <EditableContentContext.Provider value={value}>
      {children}
    </EditableContentContext.Provider>
  );
};

export const useEditableContent = () => {
  return useContext(EditableContentContext);
};
